import { render } from "./index1.vue?vue&type=template&id=a5ac5e2c"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"

import "./index1.vue?vue&type=style&index=0&id=a5ac5e2c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__